import { StaticImage } from "gatsby-plugin-image"
import { generateImageUrl } from "@utils"
import * as React from "react"

interface ReviewProps {
  isPicture?: boolean
  title?: string
  description?: string
  stars?: number
  profileTitle?: string
  isCentered?: boolean
  profileDescription?: string
  isReverse?: boolean
  isReview?: boolean
  isLoveVisualFolio?: boolean
  clientRoundedImg?: object
  clientVideo?: { asset?: { url?: string } }
}
export const Review = ({
  title,
  description,
  stars,
  profileTitle,
  isCentered = false,
  profileDescription,
  isPicture,
  isReverse = false,
  isReview = false,
  isLoveVisualFolio = false,
  clientRoundedImg = undefined,
  clientVideo = undefined,
}: ReviewProps) => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  // review
  const [review, setReview] = React.useState<Boolean>(false)
  const [showFullDescription, setShowFullDescription] = React.useState(false)
  const maxDescriptionLength = 250
  const isLongDescription =
    description && description.length > maxDescriptionLength
  const displayedDescription =
    !isLongDescription || showFullDescription
      ? description
      : description.slice(0, maxDescriptionLength) + "..."
  return (
    <div className="mt-10 overflow-hidden">
      <div
        className={`flex lg:flex-row flex-col lg:items-start items-center container mx-auto ${
          isCentered ? "justify-center text-center" : ""
        } ${isReverse ? "lg:flex-row-reverse" : ""}`}
      >
        {isPicture && (
          <div className="lg:w-[40%] w-4/5 relative">
            {isLoveVisualFolio && (
              <div className="absolute top-[-80px] left-[40%]">
                <StaticImage
                  placeholder="blurred"
                  className="w-32 mb-3"
                  src="./I-love-visualFolio.png"
                  alt="clients"
                />
              </div>
            )}
            <div className="w-full flex justify-end relative">
              {
                // isReverse ? (
                clientVideo && clientVideo.asset && clientVideo.asset.url && (
                  <>
                    <video className="w-full rounded-lg" controls>
                      <source
                        src={clientVideo.asset.url}
                        type="video/mp4"
                        autoCapitalize="true"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <div
                      className={`absolute -bottom-10 w-[50%] -z-10 ${isReverse ? "right-[-80px]" : "left-[-80px]"}`}
                    >
                      <StaticImage
                        placeholder="blurred"
                        className="w-full"
                        src="./accent.png"
                        alt="clients"
                      />
                    </div>
                  </>
                )
                // ) : (
                //   <StaticImage
                //     placeholder="blurred"
                //     className="w-full"
                //     src="./client.png"
                //     alt="clients"
                //   />
                // )}
              }
            </div>
          </div>
        )}
        <div
          className={`lg:w-[60%] pt-5 lg:pt-0 ${!isReverse ? "px-10" : "pr-10"}`}
        >
          <p
            className={`text-purple font-semibold text-center lg:text-start lg:text-xl ${
              isCentered ? "!text-center" : ""
            }`}
          >
            {title}
          </p>
          <div className={` pt-4 ${isCentered ? "text-center" : "w-full"}`}>
            <p
              className={`text-black lg:text-sm text-center lg:text-start font-semibold ${
                isCentered ? "!text-center" : ""
              }`}
            >
              {displayedDescription}
              {isLongDescription && (
                <span
                  className="text-[#7B68EC] cursor-pointer font-semibold ml-2"
                  onClick={() => setShowFullDescription((prev) => !prev)}
                >
                  {showFullDescription ? "See less" : "See more"}
                </span>
              )}
            </p>
          </div>
          <div
            className={`flex mt-8 ${
              isCentered ? "justify-center" : "lg:justify-start justify-center"
            }`}
          >
            {Array(stars)
              .fill(null)
              .map((_, index) => (
                <div key={index} className="flex items-end mb-4">
                  <StaticImage
                    placeholder="blurred"
                    className="w-5"
                    src="./star.png"
                    alt="stars"
                  />
                </div>
              ))}
          </div>
          <div>
            <div
              className={`flex gap-2 items-center ${
                isCentered
                  ? "justify-center"
                  : "lg:justify-start justify-center"
              }`}
            >
              {clientRoundedImg !== undefined ? (
                <div className=" rounded-full">
                  <img
                    src={generateImageUrl(clientRoundedImg)}
                    alt="Darren Roos"
                    loading="lazy"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                </div>
              ) : (
                <div className="w-10 h-10 bg-[#7B68EC] rounded-full"></div>
              )}
              <div>
                <p className="text-black">{profileTitle}</p>
                <p className="text-black font-light text-xs">
                  {profileDescription}
                </p>
              </div>
            </div>
          </div>
          {/* excelent */}
          <div
            className={`pt-8 ${
              isCentered
                ? "flex justify-center"
                : "flex lg:justify-start justify-center"
            }`}
          >
            <div className="w-2/5">
              {theme === "glassy" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./excelent.png"
                    alt="clients"
                  />
                </div>
              ) : theme === "light" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./light-theme.png"
                    alt="clients"
                  />
                </div>
              ) : theme === "dark" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./dark-theme.png"
                    alt="clients"
                  />
                </div>
              ) : (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./excelent.png"
                    alt="clients"
                  />
                </div>
              )}
            </div>
          </div>
          {isReview && (
            <div className="w-full flex justify-center mt-10">
              <button
                onClick={() => setReview(!review)}
                className="flex cursor-pointer gap-2 text-center items-center justify-center "
              >
                <p className="text-[#7B68EC] text-center font-semibold underline">
                  Visual Folio Response
                </p>
                <p
                  className={`text-[#7B68EC] text-center font-semibold transition duration-300 ease-in ${review ? "rotate-180" : ""}`}
                >
                  ⌵
                </p>
              </button>
            </div>
          )}
        </div>
      </div>
      {review && (
        <div className="lg:px-10 px-2">
          <div className={`flex gap-2`}>
            <div
              className={`w-8 h-8 rounded-full mt-[1px] ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
            >
              <StaticImage
                placeholder="blurred"
                className="w-full"
                src="./visual-logo.png"
                alt="clients"
              />
            </div>
            <div className="pr-5">
              <p className="text-black">Visual Folio</p>
              <p className="text-black font-medium text-xs">
                Heartfelt Thanks for your Feedback!
              </p>
              <p className="text-black font-medium text-sm mt-10">
                Dear {profileTitle},
              </p>
              <p className="text-black font-medium text-sm mt-5 text-justify">
                Thank you so much for taking the time to share your feedback on
                our work. Your kind words mean the world to us and motivate us
                to continue delivering our best ❣️
              </p>
              <p className="text-black font-medium text-sm mt-5 text-justify">
                We're thrilled to hear that you were impressed with the results
                of the project and found value in our collaboration. Your trust
                and support were instrumental in achieving such a successful
                outcome 🏆
              </p>
              <p className="text-black font-medium text-sm mt-5 text-justify">
                If there's anything more we can assist you with in the future,
                please don't hesitate to reach out. We look forward to the
                possibility of working together again🤝
              </p>
              <p className="text-black font-medium text-sm mt-5 text-justify">
                Warm Regards
              </p>
              <p className="text-black font-medium text-sm text-justify">
                Visual Folio✨
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
